import {
  SectionOne,
  CHANGE_TYPE,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-one/section-one';
import {
  SectionTwo,
  CHANGE_QUESTIONS,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two';
import {
  SectionThree,
  START_AND_END_DATE,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-three/section-three';
import {
  SectionFour,
  CHANGE_DETAILS,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-four/section-four';
import {
  SectionFive,
  WORK_INFORMATION_ITEMS,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-five/section-five';
import {
  ReferencesSection,
  REFERENCES_SECTION,
} from 'AppSrc/core/components/forms/form-types/create-crq/references-section/references-section';
import {
  ApproversSection,
  APPROVERS_SECTION,
} from 'AppSrc/core/components/forms/form-types/create-crq/approvers-section/approvers-section';
import {
  CHANGE_REQUEST_SUMMARY,
  ChangeRequestSummary,
} from 'AppSrc/core/components/forms/form-types/create-crq/section-change-request-summary/section-change-request-summary';
import {
  RELATIONSHIPS,
  Relationships,
} from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships';

// Single source of truth for the component of each section within create-crq,
const createCrqSectionComponents = {
  [CHANGE_TYPE]: SectionOne,
  [CHANGE_QUESTIONS]: SectionTwo,
  [START_AND_END_DATE]: SectionThree,
  [CHANGE_DETAILS]: SectionFour,
  [WORK_INFORMATION_ITEMS]: SectionFive,
  [REFERENCES_SECTION]: ReferencesSection,
  [APPROVERS_SECTION]: ApproversSection,
  [CHANGE_REQUEST_SUMMARY]: ChangeRequestSummary,
  [RELATIONSHIPS]: Relationships,
};

export { createCrqSectionComponents };
